var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.366 0.234315C15.6784 0.546734 15.6784 1.05327 15.366 1.36569L8.93152 7.80015L15.366 14.2346C15.6784 14.547 15.6784 15.0536 15.366 15.366C15.0536 15.6784 14.547 15.6784 14.2346 15.366L7.80015 8.93152L1.36569 15.366C1.05327 15.6784 0.54674 15.6784 0.23432 15.366C-0.0780991 15.0536 -0.0780991 14.547 0.23432 14.2346L6.66878 7.80015L0.234315 1.36569C-0.0781049 1.05327 -0.0781049 0.546735 0.234315 0.234316C0.546734 -0.0781037 1.05327 -0.0781037 1.36569 0.234316L7.80015 6.66878L14.2346 0.234315C14.547 -0.0781049 15.0536 -0.0781049 15.366 0.234315Z",
    fill: "#FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.d2ae434394a70f713e4dc36f4e466626.svg";
export { ForwardRef as ReactComponent };